import {DocumentContext, DocumentEntityType} from '@sollapay/enums';
import {FormSectionHeading} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {DocumentsAutoFillTip, DocumentUploadTabs} from '@/features/documents';
import {buildPurchaseDocumentTabs} from '@/features/purchases/utils';
import {useTrustTypeStrategy} from '@/features/trust-accounts/providers';

import type {FC} from 'react';

interface DocumentUploadSectionProps {
  trustAccountId: string;
  /** Unique per "Add Buyer" open — tags/filters uploads so a leftover document from a
   * previous (abandoned or completed) attempt is never shown or fed into AI extraction. */
  uploadSessionId: string;
  onDocumentsChange: (documentIds: string[]) => void;
}

export const DocumentUploadSection: FC<DocumentUploadSectionProps> = ({
  trustAccountId,
  uploadSessionId,
  onDocumentsChange
}) => {
  const {t} = useTranslation(['trustAccounts', 'common']);
  const strategy = useTrustTypeStrategy();

  const tabs = buildPurchaseDocumentTabs(strategy, t);

  return (
    <div className="flex flex-col gap-4">
      <FormSectionHeading title={t('trustAccounts:view.buyers.addBuyerModal.documents.title')} />
      <DocumentsAutoFillTip />
      <DocumentUploadTabs
        entityType={DocumentEntityType.TRUST_ACCOUNT}
        entityId={trustAccountId}
        documentContext={DocumentContext.PURCHASE_DOCUMENTS}
        metadata={{sessionId: uploadSessionId}}
        metadataFilter={{sessionId: uploadSessionId}}
        tabs={tabs}
        defaultValue={tabs[0]?.value}
        onDocumentsLoaded={onDocumentsChange}
      />
    </div>
  );
};
